﻿import $ from 'jquery';
import { ErrorPopover } from "./errorpopover";
import { FormValidation, IValidationHandler } from "./formvalidation"

export class RadioValidationHandler implements IValidationHandler {
  handle($error: JQuery): boolean {
    var $radioField = $error.closest('.input-radio-fields');
    var isRadio = $radioField.length > 0;
    if (!isRadio)
      return false;

    if ($radioField.data('error-handled') == true)
      return true;

    var errorMessage = $error.html();
    $radioField.data('error-handled', true);
    var id = Math.random().toString();
    $error.remove();
    new ErrorPopover().append($radioField, id, errorMessage, 'focusin');

    return true;
  }
}
